const api = {}
api.login = {
	// 获得公钥
	publicKey: '/rsa/publicKey',
	loginByPwd: '/userLogin/loginByPwd',
	loginBySmsCode: '/userLogin/loginBySmsCode',
	getVsCode: '/userLogin/sendLoginSmsCode',
	getPass: '/user/hadPwd', // 判断是否有密码
	passManager: '/user/modPwd',
	loginChart: '/chat/getChatPwd' // 环信登录
}
api.active = {
	choose: '/payKey/usePayKey',
	detail: '/payKey/authGetOrderInfoByGetId',
	moduleDetail: '/payKey/getOrderInfoByGetId',
	exchangeCode: '/payKey/getOrderInfoByGetCodeKey' //兑换码
}
// 店铺信息
api.shop = {
	edit: '/moduleShop/modSelf',
	get: '/moduleShop/getById',
	marketList: '/moduleShop/listMall',
	marketGroup: '/moduleShop/listMallGroup',
	childGroup: '/moduleShop/listChildGroup',
	collect: '/collectPerson/listUserByPage'
}
api.money = {
	get: '/money/getMoney',
	getDetail: '/money/getModuleMainInfo',
	bindWxInfo: '/moneyOutInfo/bindWxInfo',
	aBindWxInfo: '/moneyOutInfo/aBindWxInfo',
	bindAliInfo: '/moneyOutInfo/bindAliInfo',
	aBindAliInfo: '/moneyOutInfo/aBindAliInfo',
	getInfo: '/moneyOutInfo/getInfo',
	hdsl:'/statistics/getTotalActivityNum'
}
export default api



// WEBPACK FOOTER //
// ./src/assets/js/api.js